import React, { useRef, useEffect, useState, memo } from "react";
import { useDrag } from "react-use-gesture"; //Ver.6でないと動かない！！
import { useThree } from "@react-three/fiber";

// ---------------------------------
// ドラッグ可能な点
// XZ平面,YZ平面,XY平面のいずれかで動作する
//
// vpoint: Vector3
// callMove: 移動時のコールバック
// callEnd: ドラッグ完了時のコールバック
// ---------------------------------

/**
 * Represents a draggable 2D point.
 *
 * @param {string} uuid - The unique identifier of the point.
 * @param {Object} vpoint - The 3D coordinates of the point.
 * @param {string} color - The color of the point.
 * @param {number} size - The size of the point.
 * @param {number} angle - The angle of the view.
 * @param {Function} callMove - The callback function called when the point is moved.
 * @param {Function} callEnd - The callback function called when the dragging ends.
 * @returns {JSX.Element} - The draggable point component.
 */
export const PointDrag2D = memo(({ uuid, vpoint, color, size, angle, callMove, callEnd }) => {
  const [node, setNode]       = useState([]); //現在座標([])
  const ref = useRef();
  const { camera } = useThree();
  var zoom = camera.zoom;

  useEffect(() => {
    setNode([vpoint.x, vpoint.y, vpoint.z]);
  }, [vpoint]);

  useEffect(() => {
    ref.current.position.set(...node);
  }, [node]);

  const bindDrag = useDrag(
    ({ movement:[mx, my], down, event }) => {
      if(angle == 0) return;
      if (event) event.stopPropagation();
      var position;

      // 1:Front 2:Back 3:Top 4:Bottom 5:Right 6:Left
      switch(angle){
        case 1: //Front
          //position = [vpoint.x + mx/zoom, 0, vpoint.z - my/zoom];
          position = [vpoint.x + mx/zoom, vpoint.y + my/zoom, 0];
          break;
        case 2: //Back
          //position = [vpoint.x - mx/zoom, 0, vpoint.z - my/zoom];
          position = [vpoint.x - mx/zoom, vpoint.y + my/zoom, 0];
          break;
        case 3: //Top
          position = [vpoint.x + mx/zoom, 0, vpoint.y + my/zoom];
          break;
        case 4: //Bottom
          position = [vpoint.x + mx/zoom, 0, vpoint.y - my/zoom];
          break;
        case 5: //Right
          position = [0, vpoint.y - my/zoom, vpoint.z + mx/zoom];
          break;
        case 6: //Left
          position = [0, vpoint.y - my/zoom, vpoint.z - mx/zoom];
          break;
        default:
          console.log("Can't Drag in Free View");
          break;
      }

      setNode(position);
      if(callMove) callMove(uuid, position);
      if((down == false) && callEnd) callEnd(uuid, position);
    },
    { pointerEvents: true }
  );

  return (
    <mesh ref={ref} {...bindDrag()} renderOrder={1}>
      <sphereGeometry attach="geometry" args={[size, 16, 16]}/>
      <meshBasicMaterial attach="material" color={color} depthTest={false}/>
    </mesh>
  );
});

/**
 * Renders draggable 2D points.
 *
 * @param {Object[]} vpoints - The array of points to render.
 * @param {string} color - The color of the points.
 * @param {number} size - The size of the points.
 * @param {number} angle - The angle of the points.
 * @param {Function} callMove - The callback function called when a point is moved.
 * @param {Function} callEnd - The callback function called when a point dragging ends.
 * @returns {JSX.Element|null} The rendered draggable points or null if no points are provided.
 */
export const PointsDrag2D = memo(({ vpoints, color, size, angle, callMove, callEnd }) => {
  var objects = [];
  vpoints.forEach((v, i) => {
    objects.push(
      <PointDrag2D key={i} uuid={i} vpoint={v} color={color} size={size} angle={angle} callMove={callMove} callEnd={callEnd}/>
    );
  });

  return objects.length !== 0 ? (
    <React.Fragment>{objects}</React.Fragment>
  ) : null;
});
